export default __webpack_public_path__ + "static/media/on.6e8db5ec.png";